import { SearchDocSortType } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { ListItemType, ListView } from 'src/common/components/list-view';
import { useOpenModal } from 'src/common/components/next-modal';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export interface SortSwitchProps {
  sortType: SearchDocSortType;
  onSwitchType: (type: SearchDocSortType) => void;
}
export const SortSwitch: FC<SortSwitchProps> = (props) => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();

  const getSortTypeLabel = (sortType: SearchDocSortType) => {
    switch (sortType) {
      case SearchDocSortType.RELEVANCE:
        return t('views.header.search.sort_type.relevance');
      case SearchDocSortType.LAST_EDITED_NEWEST:
        return t('views.header.search.sort_type.created_newest');
      case SearchDocSortType.LAST_EDITED_OLDEST:
        return t('views.header.search.sort_type.created_oldest');
      case SearchDocSortType.CREATED_NEWEST:
        return t('views.header.search.sort_type.last_edited_newest');
      case SearchDocSortType.CREATED_OLDEST:
        return t('views.header.search.sort_type.last_edited_oldest');
      default:
        return '';
    }
  };

  const onClick = (e: React.MouseEvent) => {
    const items = Object.values(SearchDocSortType).map((sortType) => {
      return {
        type: ListItemType.OPERATION,
        data: {
          sortType: sortType as SearchDocSortType,
          title: getSortTypeLabel(sortType as SearchDocSortType),
          hasArrow: props.sortType === sortType,
          arrow: <Icon size="normal" name="IcCheck02" />,
        },
      };
    });
    openModal.dropdown({
      popcorn: e.target as HTMLElement,
      placement: 'top',
      content: ({ onCloseModal }) => {
        return (
          <div className="next-modal w-[246px] py-1">
            <ListView
              items={items}
              onItemClick={(_, index) => {
                const item = items[index];
                if (item) {
                  props.onSwitchType(item.data.sortType);
                  onCloseModal();
                }
              }}
            />
          </div>
        );
      },
    });
  };
  return (
    <div
      className="ml-[2px] rounded-sm cursor-pointer px-1.5 py-[2px] flex text-t2-medium items-center text-grey3 text-center hover:bg-black_006"
      onClick={onClick}
    >
      <div>{getSortTypeLabel(props.sortType)}</div>
      <Icon className="ml-1" name={'IcArrowDown01'} size="tiny"></Icon>
    </div>
  );
};
